import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as EntertainmentEventBookingActions from '../actions/entertainment-event-booking.actions';

@Injectable()
export class EntertainmentEventBookingEffects {
  constructor(private actions$: Actions, private http: HttpClient) {}

  public createBooking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentEventBookingActions.CREATE_BOOKING),
      switchMap((action: EntertainmentEventBookingActions.CreateBooking) => {
        const newBookingData = {
          'performance': action.payload.performance,
          'tickets': [
            {
              quantity: action.payload.tickets[0].quantity,
              ticket_type: action.payload.tickets[0].ticket_type,
            },
          ],
          'g-recaptcha-response': action.payload.tickets[0].recaptcha,
        };

        return this.http.post(ApiEndpoint.ENTERTAINMENT_TICKET_BOOKINGS, newBookingData).pipe(
          map((booking) => new EntertainmentEventBookingActions.CreateBookingSuccess(booking)),
          catchError((error) => of(new EntertainmentEventBookingActions.CreateBookingFail(error)))
        );
      })
    )
  );

  public updateBooking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentEventBookingActions.UPDATE_BOOKING),
      switchMap((action: EntertainmentEventBookingActions.UpdateBooking) => {
        const url = `${ApiEndpoint.ENTERTAINMENT_TICKET_BOOKINGS}${action.payload.id}/`;

        return this.http.patch(url, action.payload.data).pipe(
          map((booking) => new EntertainmentEventBookingActions.UpdateBookingSuccess(booking)),
          catchError((error) => of(new EntertainmentEventBookingActions.UpdateBookingFail(error)))
        );
      })
    )
  );

  public viewBooking$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentEventBookingActions.VIEW_BOOKING),
      switchMap((action: EntertainmentEventBookingActions.ViewBooking) => {
        const url = `${ApiEndpoint.ENTERTAINMENT_TICKET_BOOKINGS}${action.payload}/`;

        return this.http.get(url).pipe(
          map((booking) => new EntertainmentEventBookingActions.ViewBookingSuccess(booking)),
          catchError((error) => of(new EntertainmentEventBookingActions.ViewBookingFail(error)))
        );
      })
    )
  );

  public updateBookingOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EntertainmentEventBookingActions.UPDATE_BOOKING_ORDER),
      switchMap((action: EntertainmentEventBookingActions.UpdateBookingOrder) => {
        const url = replaceTemplateKeys(ApiEndpoint.ENTERTAINMENT_TICKET_BOOKINGS_ORDER, {
          id: action.payload.id.toString(),
        });

        return this.http.patch(url, action.payload.data).pipe(
          map((booking) => new EntertainmentEventBookingActions.UpdateBookingOrderSuccess(booking)),
          catchError((error) => of(new EntertainmentEventBookingActions.UpdateBookingOrderFail(error)))
        );
      })
    )
  );
}
